<template>
  <div id="app">
    <el-container style="height: 100vh">
      <el-header class="app-header">
        <div class="image-container">
          <div class="loginImg">
            <img src="@/assets/tp.png" :style="{ width: '100%', height: 'auto', objectFit: 'cover'}">
          </div>
        </div>
        <div class="header-title">
          <h2>装置在线监测系统</h2>
        </div>
        <div class="data-box">
          <span class="f14rem">{{date.split(" ")[2]}}</span>
          <span class="f14rem">{{date.split(" ")[1]}}</span>
          <span class="f14rem fdata">{{date.split(" ")[0]}}</span>
        </div>
        <el-tooltip content="主站设置" placement="bottom">
         <div class="settingImg" @click="onClickSetting()">
          <i class="el-icon-setting" style="font-size: larger;"></i>
         </div>
        </el-tooltip>
        <el-tooltip content="设备配置" placement="bottom">
          <div class="settingImg" @click="configVisible = true" style="right: 72px;">
            <i class="el-icon-s-tools" style="font-size: larger;"></i>
          </div>
        </el-tooltip>
        <master-setting :visible.sync="settingVisible" @saved="onSettingSaved"/>
        <!-- <wave-inf :visible.sync="infVisible" :record="currentRecord" :inf-data="infData" :record-type="currentRecord.recordType"/> -->
        <wave-chart :visible.sync="waveChartVisible" :record="currentWave"/>
        <config-management :visible.sync="configVisible"/>
      </el-header>
      <el-container>
        <el-aside width="220px" class="app-aside">
          <div class="mqtt-tab">
            <div class="tree_head">
              <i class="el-icon-folder-opened"></i>
              <span>录波文件</span>
            </div>
          </div>
          <div class="tree-body">
            <el-tree
              :data="topicTree"
              :props="{ label: 'name', children: 'children' }"
              node-key="id"
              highlight-current
              :expand-on-click-node="false"
              @node-click="handleNodeClick"
            >
              <span slot-scope="{ node }" class="tree-node-label">
                <i class="el-icon-folder" style="color: #fbbf24;"></i>
                {{ node.label }}
              </span>
            </el-tree>
          </div>
        </el-aside>

        <el-main class="app-main">
          <el-card class="search-card" shadow="never">
            <el-form :inline="true" size="small" @submit.native.prevent>
              <el-form-item label="主题">
                <el-input
                  v-model="searchParams.topic"
                  placeholder="请输入主题"
                  clearable
                  prefix-icon="el-icon-search"
                  style="width: 150px"
                />
              </el-form-item>
              <el-form-item label="文件名称">
                <el-input
                  v-model="searchParams.fileName"
                  placeholder="请输入文件名"
                  clearable
                  prefix-icon="el-icon-search"
                  style="width: 180px"
                />
              </el-form-item>
              <el-form-item label="开始时间">
                <el-date-picker
                  v-model="searchParams.startTime"
                  type="datetime"
                  placeholder="选择开始时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 140px"
                />
              </el-form-item>
              <el-form-item label="结束时间">
                <el-date-picker
                  v-model="searchParams.endTime"
                  type="datetime"
                  placeholder="选择结束时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 140px"
                />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
                <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
              </el-form-item>
            </el-form>
          </el-card>

          <el-card class="table-card" shadow="never">
            <el-table
              :data="displayRows"
              v-loading="loading"
              :max-height="tableMaxHeight"
              row-key="key"
              :row-class-name="rowClassName"
              @row-click="handleRowClick"
            >
              <el-table-column prop="receivedTime" label="时间" width="170" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.__group" class="group-row">
                    <i :class="scope.row.expanded ? 'el-icon-caret-bottom' : 'el-icon-caret-right'"
                       style="color: #0d9488; margin-right: 4px;"></i>
                    <b>{{ scope.row.fz }}</b>
                    <span class="group-count">({{ scope.row.count }})</span>
                  </span>
                  <span v-else>{{ scope.row.receivedTime }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="topic" label="主题" min-width="100" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span v-if="!scope.row.__group">{{ scope.row.topic }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="recordType" label="录波类型" width="100" align="center">
                <template slot-scope="scope">
                  <span v-if="!scope.row.__group">{{ scope.row.recordType }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="fileName" label="文件名" min-width="260" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                  <template v-if="!scope.row.__group">
                    <i class="el-icon-document" style="color: #0d9488; margin-right: 4px;"></i>
                    {{ scope.row.fileName }}
                  </template>
                </template>
              </el-table-column>
            <el-table-column label="操作" width="260" align="center" fixed="right">
              <template slot-scope="scope">
                <template v-if="!scope.row.__group">
                <!-- <el-button type="primary" size="mini" plain class="op-btn" @click="viewDetail(scope.row)">
                  查看
                </el-button> -->
                <el-button type="primary" size="mini" plain class="op-btn" @click="showWaveEchart(scope.row)">
                  查看
                </el-button>
                <el-button type="success" size="mini" plain class="op-btn" @click="publishData(scope.row)">
                  发布
                </el-button>
                <el-button type="danger" size="mini" plain class="op-btn" @click="deleteData(scope.row)">
                  删除
                </el-button>
                <el-button type="info"  size="mini" plain class="op-btn" @click="downloadData(scope.row)">
                  下载
                </el-button>
                </template>
              </template>
            </el-table-column>
            </el-table>

            <div class="pagination-bar">
              <el-pagination
                @current-change="handlePageChange"
                :current-page="pageNum"
                :page-size="pageSize"
                :total="total"
                background
                layout="total, prev, pager, next"
              />
            </div>
          </el-card>
        </el-main>
      </el-container>
    </el-container>

    <el-dialog title="查看" :visible.sync="detailVisible" width="700px" class="detail-dialog">
      <el-descriptions :column="1" border size="medium" labelClassName="desc-label">
        <el-descriptions-item label="录波类型">{{ currentRecord.recordType }}</el-descriptions-item>
        <el-descriptions-item label="文件名">{{ currentRecord.fileName }}</el-descriptions-item>
        <el-descriptions-item label="接收时间">{{ currentRecord.receivedTime }}</el-descriptions-item>
        <el-descriptions-item label="主题">{{ currentRecord.topic }}</el-descriptions-item>
      </el-descriptions>
      <span slot="footer">
        <el-button @click="detailVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import MasterSetting from './components/MasterSetting.vue'
import WaveChart from './components/WaveChart.vue'
import ConfigManagement from './components/ConfigManagement.vue'

const API_BASE = '/mqtt'

export default {
  name: 'App',
  components: {
    MasterSetting,
    // WaveInf,
    WaveChart,
    ConfigManagement
  },
  data() {
    return {
      settingVisible: false,
      infVisible: false,
      waveChartVisible: false,
      currentWave: {},
      configVisible: false,
      infData: {},
      date: "",
      topicTree: [],
      currentTopic: '',
      recordList: [],
      loading: false,
      pageNum: 1,
      pageSize: 20,
      total: 0,
      tableMaxHeight: 380,
      detailVisible: false,
      currentRecord: {},
      searchParams: {
        topic: '',
        fileName:'',
        startTime: '',
        endTime: ''
      },
      groupState: {}, //各组展开状态
      groupCounts: {} //各分组全量条数(跨页合计)
    }
  },
  computed: {
    displayRows() {
      const rows = []
      const groups = {}
      const order = []
      for (const r of this.recordList) {
        const fz = r.fz
        if (!groups[fz]) {
          groups[fz] = []
          order.push(fz)
        }
        groups[fz].push(r)
      }
      for (const fz of order) {
        const expanded = this.groupState[fz] !== undefined ? this.groupState[fz] : true
        //组头条数用接口的全量统计(跨页合计), 无则退回当前页数量
        const total = this.groupCounts[fz] !== undefined ? this.groupCounts[fz] : groups[fz].length
        rows.push({ __group: true, key: 'g_' + fz, fz: fz, count: total, expanded: expanded })
        if (expanded) {
          for (const r of groups[fz]) {
            rows.push(Object.assign({ __group: false, key: r.id }, r))
          }
        }
      }
      return rows
    }
  },
  mounted() {
    this.currentTime()
    this.loadTopics()
    this.loadRecords()
    this.computeTableHeight()
    window.addEventListener('resize', this.computeTableHeight)
    document.addEventListener('click', this.blurButtonAfterClick)
  },
  beforeDestroy() {
    if (this.formatDates) {
      clearInterval(this.currentTime());
    }
    window.removeEventListener('resize', this.computeTableHeight)
    document.removeEventListener('click', this.blurButtonAfterClick)
  },
  methods: {
    toggleGroup(fz) {
      const cur = this.groupState[fz] !== undefined ? this.groupState[fz] : true
      this.$set(this.groupState, fz, !cur)
    },

    handleRowClick(row) {
      if (row.__group) {
        this.toggleGroup(row.fz)
      }
    },

    rowClassName({ row }) {
      return row.__group ? 'record-group-row' : ''
    },

    blurButtonAfterClick(e) {
      const btn = e.target && e.target.closest && e.target.closest('button')
      if (btn) btn.blur()
    },
    computeTableHeight() {
      this.tableMaxHeight = Math.max(300, window.innerHeight - 340)
    },
    currentTime() {
      setInterval(()=>{
        this.date = this.formatDates()
      },1000)
    },
    formatDates(){
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      month = month < 10 ? '0' + month : month
      let day = date.getDate()
      day = day < 10 ? '0' + day : day
      let week = date.getDay()
      let weekArr = [ '周日', '周一', '周二', '周三', '周四', '周五', '周六' ]
      let hour = date.getHours()
      hour = hour < 10 ? '0' + hour : hour
      let minute = date.getMinutes()
      minute = minute < 10 ? '0' + minute : minute
      let second = date.getSeconds()
      second = second < 10 ? '0' + second : second
      return `${hour}:${minute}:${second} ${weekArr[week]} ${year}年${month}月${day}日`
    },
    onClickSetting() {
      this.settingVisible = true
    },
    onSettingSaved() {
      console.log('主站配置已更新')
      this.$message.success('主站配置已更新')
    },
    async loadTopics() {
      try {
        const res = await axios.get(`${API_BASE}/topics/tree`)
        if (res.data.code === 200) {
          this.topicTree = res.data.data || []
        }
      } catch (error) {
        console.error('加载主题树失败:', error)
        this.$message.error('加载主题树失败')
      }
    },

    async publishData(row) {
      try {
        const res = await axios.post(`${API_BASE}/publish`, null, {
          params: {
            topic: row.topic,
            fileName: row.fileName
          }
        })

        if (res.data.code === 200) {
          this.$message.success('发布成功')
        } else {
          this.$message.error(res.data.message)
        }
      } catch (error) {
        console.error('发布失败:', error)
        this.$message.error('发布失败')
      }
    },

    async deleteData(row) {
      this.$confirm('确定删除这条数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await axios.delete(`${API_BASE}/delete/${row.id}`)
          if (res.data.code === 200) {
            this.$message.success('删除成功')
            this.loadRecords()
          } else {
            this.$message.error(res.data.message)
          }
        } catch (error) {
          console.error('删除失败')
          this.$message.error('删除失败')
        }
      }).catch(() => {})
    },

    async downloadData(row) {
      const url = `${API_BASE}/download?topic=${encodeURIComponent(row.topic)}&fileName=${encodeURIComponent(row.fileName)}`
      //window.open(url, '_blank')
      let link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.download = `${row.fileName}.zip`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link) 
    },
    handleNodeClick(data) {
      if (data.type === 'topic') {
        this.currentTopic = data.fullPath
        this.searchParams.topic = data.fullPath
        this.pageNum = 1
        this.loadRecords()
      }
    },

    handleSearch() {
      this.pageNum = 1
      this.currentTopic = this.searchParams.topic
      this.loadRecords()
    },

    resetSearch() {
      this.searchParams = {
        topic: '',
        startTime: '',
        endTime: ''
      }
      this.currentTopic = ''
      this.pageNum = 1
      this.loadRecords()
    },
    async loadRecords() {
      this.loading = true
      try {
        const params = {
          page: this.pageNum,
          size: this.pageSize
        }

        if (this.searchParams.topic) {
          params.topic = this.searchParams.topic
        }
        if(this.searchParams.fileName)
        {
          params.fileName = this.searchParams.fileName
        }
        if (this.searchParams.startTime) {
          params.startTime = this.searchParams.startTime
        }
        if (this.searchParams.endTime) {
          params.endTime = this.searchParams.endTime
        }

        const res = await axios.get(`${API_BASE}/records`, { params })

        if (res.data.code === 200) {
          this.recordList = res.data.data.records || []
          this.total = res.data.data.total || 0
          //各分组全量条数(跨页合计), 组头显示用
          this.groupCounts = {}
          const groups = res.data.data.groups || []
          for (const g of groups) {
            this.$set(this.groupCounts, g.fz, g.c)
          }
        }
      } catch (error) {
        console.log('加载记录失败')
        this.$message.error('加载记录失败')
      } finally {
        this.loading = false
      }
    },

    handlePageChange(page) {
      this.pageNum = page
      this.loadRecords()
    },

    async viewDetail(row) {
      try {
        const res = await axios.post(`${API_BASE}/detail`, null, {
          params: {
            topic: row.topic,
            fileName: row.fileName
          }
        })
        if (res.data.code != 200) {
          console.log(res.data.message)
          this.$message.error(res.data.message)
        }
      } catch (error) {
        this.$message.error('打开 WaveTool 失败')
      }
    },

    async showWaveEchart(row)
    {
      this.currentWave = row
      this.waveChartVisible = true
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Microsoft YaHei", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
}

/* ========== 顶部栏 ========== */
.app-header {
  background: linear-gradient(135deg, #0d9488 0%, #0f766e 60%, #115e59 100%);
  color: white;
  line-height: 60px;
  position: relative;
  box-shadow: 0 2px 12px rgba(13, 148, 136, 0.35);
  z-index: 10;
}

.header-title h2 {
  font-weight: 500;
  letter-spacing: 3px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
  text-align: center;
  /*font-size: 24px;*/
  font-size: 1.5rem;
}

.image-container {
  position: absolute;
  width: 120px;
  height: 100%;
  overflow: hidden;
  vertical-align: middle;
}

.loginImg {
  height: 80%;
  vertical-align: middle;
  display: inline-block;
}

.data-box {
  position: absolute;
  right: 8%;
  top: 0;
  width: 250px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}

.settingImg {
  position: absolute;
  right: 30px;
  top: 15px;
  width: 32px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  cursor: pointer;
  opacity: 1;
  transition: transform 0.2s ease;
  outline: none;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
}

.settingImg:focus,
.settingImg img:focus {
  outline: none;
}

.settingImg img {
  -webkit-tap-highlight-color: transparent;
  user-select: none;
  pointer-events: none;
}

.settingImg:focus,
.settingImg img:focus {
  outline: none;
}

.settingImg img {
  -webkit-tap-highlight-color: transparent;
  user-select: none;
  pointer-events: none;
}

.settingImg:hover {
  opacity: 1;
  transform: scale(1.15);
}

.settingImg:active {
  transform: scale(0.95);
}

.f14rem {
  font-size: 0.85rem;
  color: #f0fdfa;
  letter-spacing: 0;
  line-height: 2.6rem;
  font-weight: 500;
  margin-left: 0.6rem;
}

.fdata {
  font-size: 0.7rem;
  color: #99f6e4;
}

/* ========== 侧边栏 ========== */
.app-aside {
  background: linear-gradient(180deg, #0f766e 0%, #134e4a 100%);
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.08);
}

.mqtt-tab {
  position: relative;
  width: 100%;
  height: 44px;
}

.tree_head {
  width: 100%;
  vertical-align: middle;
  text-align: center;
  height: 100%;
  background: rgba(0, 0, 0, 0.18);
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  line-height: 44px;
  color: #fff;
  font-weight: 500;
  letter-spacing: 2px;
}

.tree_head i {
  color: #fbbf24;
  margin-right: 4px;
}

.tree-body {
  padding: 8px 10px;
}

.el-tree {
  background: transparent !important;
}

.el-tree-node__content {
  background-color: transparent !important;
  color: #ccfbf1;
  border-radius: 6px;
  height: 32px;
  margin-bottom: 2px;
  transition: background-color 0.2s ease;
}

.el-tree-node__content:hover {
  background-color: rgba(255, 255, 255, 0.12) !important;
}

.el-tree-node.is-current > .el-tree-node__content {
  background-color: rgba(255, 255, 255, 0.22) !important;
  color: #fff;
  font-weight: 600;
}

.el-tree-node__label {
  color: #ccfbf1;
}

.el-tree-node.is-current > .el-tree-node__content .el-tree-node__label {
  color: #fff;
}

.el-tree-node__expand-icon {
  color: #5eead4;
}

.el-tree-node__expand-icon.is-leaf {
  color: transparent;
}

.tree-node-label{
  font-size: 14px;
}

/* ========== 主区域 ========== */
.app-main {
  background-color: #eef2f5;
  padding: 16px;
}

.search-card {
  border-radius: 10px;
  border: none;
  margin-bottom: 14px;
}

.search-card .el-form-item {
  margin-bottom: 0;
}

.table-card {
  border-radius: 10px;
  border: none;
  padding: 2px;
}

/* ========== 表格 ========== */
.el-table {
  font-size: 13px;
}

.el-table thead th {
  background: linear-gradient(135deg, #0d9488, #14b8a6) !important;
  color: #fff !important;
  font-weight: 500;
  letter-spacing: 1px;
}

.el-table thead th,
.el-table thead tr {
  background-color: transparent;
}

.el-table td,
.el-table th.is-leaf {
  border-bottom: 1px solid #e2e8ec;
}

.el-table td,
.el-table th.is-leaf {
  border-right: 1px solid #e2e8ec;
}

.el-table thead th.is-leaf {
  border-right: 1px solid rgba(255, 255, 255, 0.25);
}

.el-table thead th.is-leaf:last-child,
.el-table td:last-child {
  border-right: none;
}

.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #f0fdfa !important;
}

.el-table::before {
  display: none;
}

.row-index {
  color: #64748b;
}

/* ========== 操作按钮 ========== */
.op-btn {
  margin-left: 2px !important;
  margin-right: 2px;
  padding: 7px 10px !important;
  font-size: 12px !important;
}

.op-btn + .op-btn {
  margin-left: 2px !important;
}

.el-table .cell .op-btn {
  white-space: nowrap;
}

.el-table__empty-block {
  background: #fafcfd;
  border-radius: 6px;
}

/* ========== 分页 ========== */
.pagination-bar {
  margin-top: 14px;
  padding: 4px 2px 2px;
  text-align: right;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #0d9488;
  color: #fff;
}

.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #0d9488;
}

/* .el-table .record-group-row td
{
  background: rgb(209, 208, 208) !important;
} */

.el-table .record-group-row {
  cursor: pointer;
}

/* .group-row{
    background: rgb(209, 208, 208) !important;
    color: #0f766e;
} */

/* ========== 弹窗 ========== */
.el-dialog {
  border-radius: 12px;
  overflow: hidden;
}

.el-dialog__header {
  background: linear-gradient(135deg, #0d9488, #14b8a6);
  padding: 14px 20px;
}

.el-dialog__title {
  color: #fff;
  font-weight: 500;
  letter-spacing: 1px;
}

.el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

.el-dialog__footer {
  padding: 10px 20px 16px;
}

.desc-label {
  width: 110px;
  background-color: #f0fdfa !important;
  color: #0f766e !important;
  font-weight: 500;
}

/* ========== 滚动条 ========== */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-thumb {
  background: #c3ced6;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #0d9488;
}

::-webkit-scrollbar-track {
  background: transparent;
}
</style>
